var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ClientError extends Error {
    constructor(message, level, type) {
        super(message);
        this.message = message;
        this.level = level;
        this.type = type;
    }
}
export function createClientErrorFromResponse(status, response) {
    try {
        const errorJson = JSON.parse(response);
        if (typeof errorJson.message === 'string' && typeof errorJson.level === 'string') {
            return new ClientError(errorJson.message, status, errorJson.level);
        }
    }
    catch (_a) { }
    return new Error(response);
}
export function createClientError(response) {
    return __awaiter(this, void 0, void 0, function* () {
        return createClientErrorFromResponse(response.status, yield response.text());
    });
}
